import { preloadImage } from '@app/lazyload.js';

let observer;

const SELECTOR_ELEMENT = '.fade-on-scroll';
const CLASSNAME_VISIBLE = 'is-visible';

const config = {
  rootMargin: '150px 90px',
  threshold: 0.5
};

const onIntersection = (entries) => {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add(CLASSNAME_VISIBLE);
    } else {
      entry.target.classList.remove(CLASSNAME_VISIBLE);
    }
  });
};

const init = () => {
  const elements = window.document.querySelectorAll(SELECTOR_ELEMENT);

  observer = new IntersectionObserver(onIntersection, config);
  elements.forEach(image => observer.observe(image));
}

export default {
  init
}
